import { SettingComponent } from "../../components";

export default function EmailSettingPage() {
  return <SettingComponent.EmailSettingPage />;
}
